import React from 'react';
import styled from 'styled-components';
import Modal from '@mui/material/Modal/Modal';
import { TrueImpactButtonWithLoading } from './TrueImpactButton';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';
import { mergeClassNames } from '../../utils/mergeClassNames';

export interface ButtonProps {
  text: string;
  disabled?: boolean;
  isLoading?: boolean;
  onClick: () => unknown;
  textColor?: keyof typeof COLORS;
  textColorHover?: keyof typeof COLORS;
  backgroundColor?: keyof typeof COLORS;
  backgroundColorHover?: keyof typeof COLORS;
}

interface TrueImpactSimpleModalProps {
  open: boolean;
  onClose: (() => unknown) | undefined;
  keepMounted?: boolean;
  hideFooter?: boolean;
  next?: ButtonProps;
  previous?: ButtonProps;
  contentClassName?: string;
  footerClassName?: string;
  contentStyle?: React.CSSProperties;
  footerStyle?: React.CSSProperties;
  children?: React.ReactNode | React.ReactNode[];
}

const StyledDiv = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .modal-content {
    background-color: ${COLORS.whiteBase};
    .footer {
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${COLORS.grayLightest};
      .next-button,
      .previous-button {
        button {
          min-width: 80px;
        }
      }
      .previous-button {
        margin-right: ${SPACERS.extraTiny};
      }
      .next-button {
        margin-left: ${SPACERS.extraTiny};
      }
    }
  }
`;

const TrueImpactSimpleModal: React.FC<TrueImpactSimpleModalProps> = ({
  open,
  keepMounted,
  children,
  hideFooter,
  next,
  previous,
  onClose,
  footerClassName,
  contentClassName,
  contentStyle,
  footerStyle,
}) => {
  return (
    <Modal
      open={open}
      onClose={(_event, reason) => {
        if (reason === 'backdropClick') return;
        onClose?.();
      }}
      keepMounted={keepMounted}
    >
      <StyledDiv>
        <div
          style={contentStyle}
          className={mergeClassNames('modal-content', contentClassName)}
        >
          <div className="content">{children}</div>
          {!hideFooter && (
            <div
              style={footerStyle}
              className={mergeClassNames('footer', footerClassName)}
            >
              {previous && (
                <TrueImpactButtonWithLoading
                  variant="secondary-large"
                  disabled={previous.disabled}
                  onClick={previous.onClick}
                  isLoading={previous.isLoading}
                  color={previous.textColor}
                  colorHover={previous.textColorHover}
                  backgroundColor={previous.backgroundColor}
                  backgroundColorHover={previous.backgroundColorHover}
                  className="previous-button"
                >
                  {previous.text}
                </TrueImpactButtonWithLoading>
              )}
              {next && (
                <TrueImpactButtonWithLoading
                  disabled={next.disabled}
                  onClick={next.onClick}
                  isLoading={next.isLoading}
                  color={next.textColor}
                  colorHover={next.textColorHover}
                  backgroundColor={next.backgroundColor}
                  backgroundColorHover={next.backgroundColorHover}
                  className="next-button"
                >
                  {next.text}
                </TrueImpactButtonWithLoading>
              )}
            </div>
          )}
        </div>
      </StyledDiv>
    </Modal>
  );
};

export default TrueImpactSimpleModal;
